import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import getParamsFromString from "../../../Utils/getParamsFromString";
import {multiLanguageValue} from "../../../Utils/lib";
import JsonScreenHoc from "../../../../../HocHelpers/JsonScreenHoc";
import PropTypes from "prop-types";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import Typography from "@material-ui/core/Typography";
import {makeStyles} from "@material-ui/core";
import {
    ExpansionPanelDetailsV, ExpansionPanelSummaryV, ExpansionPanelV,
    ExpansionPanelUnstyled, ExpansionPanelDetailsUnstyled, ExpansionPanelSummaryUnstyled,
} from "./ExpansionWrapper";
import RenderComponents from "../RenderComponents";
import useFieldErrors from "../../../Hooks/useFieldErrors";

const useStyles = makeStyles(() => ({
    panelDetails: {
        padding: '0',
        display: 'block'
    }
}))
const AccordionComponent = (props) => {
    const {
        component: {styles: sourceStyles, properties = {}, children = []},
        actionsContext, basePath, containerArrayPath
    } = props;
    const [aLabel, setALabel] = useState('')
    const [aContent, setAContent] = useState('')
    const classes = useStyles();
    const styles = sourceStyles ? sourceStyles[0] || {} : {};
    const labelStyles = sourceStyles ? sourceStyles[1] || {} : {};
    const {globalValues, screenName} = useSelector(state => state.jsonScreen);
    const {userLanguage} = useSelector(state => state.app);
    const {label, content, type} = properties;
    const [expanded, setExpanded] = useState(false);
    const {errCount} = useFieldErrors(children)

    useEffect(() => {
        if(errCount > 0) {
            setExpanded(true)
        }
    }, [errCount])
    useEffect(() => {
        const multiLanguageLabel = multiLanguageValue(label, userLanguage);
        const multiLanguageContent = multiLanguageValue(content, userLanguage);

        const currentLabel = getParamsFromString(multiLanguageLabel, {...globalValues, ...actionsContext}, screenName)
        const currentContent = getParamsFromString(multiLanguageContent, {...globalValues, ...actionsContext}, screenName)
        setALabel(currentLabel)
        setAContent(currentContent)

    }, [JSON.stringify(globalValues), JSON.stringify(actionsContext), label, content, userLanguage])

    if (type === 'unstyled') {
        return (
            <ExpansionPanelUnstyled style={{width: styles.width}}
                                    TransitionProps={{
                                        unmountOnExit: true
                                    }}
                                    expanded={expanded}
            >
                <ExpansionPanelSummaryUnstyled
                    expandIcon={<ExpandMoreIcon style={{
                        color: styles.arrowColor
                    }}/>}
                    onClick={() => setExpanded(prev => !prev)}
                >
                    <Typography style={{width: labelStyles.width}}>{aLabel}</Typography>
                </ExpansionPanelSummaryUnstyled>
                <ExpansionPanelDetailsUnstyled classes={{root: classes.panelDetails}}>
                    <div style={{
                        padding: "0px 10px"
                    }}>
                        <div dangerouslySetInnerHTML={{__html: aContent}}/>
                        {(children || []).map((element, index) => {
                            return (
                                <RenderComponents
                                    key={index}
                                    basePath={basePath}
                                    element={element}
                                    containerArrayPath={containerArrayPath}
                                    actionsContext={actionsContext}
                                />
                            )
                        })}
                    </div>
                </ExpansionPanelDetailsUnstyled>
            </ExpansionPanelUnstyled>
        )
    }

    return (
        <ExpansionPanelV style={{margin: '10px 0', width: styles.width}}
                         TransitionProps={{
                             unmountOnExit: true
                         }}
                         onClick={() => setExpanded(prev => !prev)}
                         expanded={expanded}
        >
            <ExpansionPanelSummaryV
                expandIcon={<ExpandMoreIcon style={{
                    color: styles.arrowColor
                }}/>}
            >
                <Typography><b>{aLabel}</b></Typography>
            </ExpansionPanelSummaryV>
            <ExpansionPanelDetailsV classes={{root: classes.panelDetails}}>
                <div style={{
                    padding: 10
                }}>
                    <div dangerouslySetInnerHTML={{__html: aContent}}/>
                    {(children || []).map((element, index) => {
                        return (
                            <RenderComponents
                                key={index}
                                basePath={basePath}
                                element={element}
                                containerArrayPath={containerArrayPath}
                                actionsContext={actionsContext}
                            />
                        )
                    })}
                </div>
            </ExpansionPanelDetailsV>
        </ExpansionPanelV>
    )
};
export default JsonScreenHoc(AccordionComponent);

AccordionComponent.propTypes = {
    element: PropTypes.object,
    actionsContext: PropTypes.object,
    screenName: PropTypes.string,
    globalValues: PropTypes.object
};
AccordionComponent.defaultProps = {
    actionsContext: {}
};